import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { Button } from '../../../../../../../components/Button/Button'
import styles from './FilterGroup.module.scss'

interface EditableFilterNameProps {
  name: string
  onChange: (name: string) => void
  disabled?: boolean
}

export const EditableFilterName: React.FC<EditableFilterNameProps> = ({ name, onChange, disabled = false }) => {
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [draft, setDraft] = useState<string>(name)

  const startEditing = () => {
    setDraft(name)
    setIsEditing(true)
  }

  const confirm = () => {
    const trimmed = draft.trim()
    if (trimmed) {
      onChange(trimmed)
    }
    setIsEditing(false)
  }

  const cancel = () => {
    setDraft(name)
    setIsEditing(false)
  }

  if (!isEditing) {
    return (
      <div className='d-flex align-items-center gap-2'>
        <span className='fw-bold'>{name}</span>
        {!disabled && (
          <Button type='button' className={classNames('p-1', styles.iconButton, styles.editButton)} onClick={startEditing} aria-label='Edit filter name'>
            <i className='bi bi-pencil-square' />
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className={classNames('d-flex align-items-center gap-2', styles.editNameRow)}>
      <Form.Control
        type='text'
        autoFocus
        className='flex-grow-1 p-1 zocks-bg-color-gray-100 rounded'
        value={draft}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDraft(e.target.value)}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            confirm()
          } else if (e.key === 'Escape') {
            cancel()
          }
        }}
      />
      <Button
        type='button'
        variant='secondary'
        className='d-flex align-items-center justify-content-center p-2'
        onClick={cancel}
        aria-label='Cancel filter name edit'
      >
        <i className='bi bi-x' />
      </Button>
      <Button
        type='button'
        variant='primary'
        className='d-flex align-items-center justify-content-center p-2'
        onClick={confirm}
        aria-label='Confirm filter name'
      >
        <i className='bi bi-check' />
      </Button>
    </div>
  )
}
